import * as React from 'react';
import { IPatient } from '../../../../models/IPatient';
import { Form, AlertMessage, AlertType, CustomButton, ButtonType, SpinnerWrapper, CustomSubmitButton } from 'soprasteria-ui-library';
import { ReferralManualRegisterFormInputs } from "./ReferralManualRegisterFormInputs";
import { useHistory } from 'react-router';
import { setMessage } from '../../../../helpers/MessageHelper';
import { IReferralManualRegistration, ISaveReferral, IReferralForm } from '../../../../models/IReferral';
import { useAuth } from '../../../../App';
import { ReferralManualRegistrationApi } from '../../../../api/ReferralManualRegistrationApi';
import { REFERRAL } from '../../../../utils/RouteConstants';
import { IAddress } from '../../../../models/IAddress';

interface IReferralView {
    patient: IPatient;
}

export const ReferralManualRegistration: React.FunctionComponent<IReferralView> = ({ patient }) => {
    const history = useHistory();

    const auth = useAuth();
    const api = new ReferralManualRegistrationApi(auth);

    const [initData, setInitData] = React.useState<IReferralManualRegistration>();
    const [isApiLoading, setIsApiLoading] = React.useState<boolean>(false);
    const [isSubmittingForm, setIsSubmittingForm] = React.useState<boolean>(false);

    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        setIsApiLoading(true);
        api.getManualRegistration((data) => {
            setInitData(data);
        }, (message) => changeErrorMessage(message),
            () => setIsApiLoading(false));
    }, [])

    const submitReferralForm = (formData: IReferralForm) => {
        const referralData = mapFormData(formData);
        createReferral(referralData);
    }

    const createReferral = (formData: ISaveReferral) => {
        setIsSubmittingForm(true);
        api.createManualRegisteredReferral(formData, (newReferralId) => {
            changeSuccessMessage("Specialistremissen skickad")
            history.replace(`${REFERRAL}/${newReferralId}`);
        }, (message) => changeErrorMessage(message),
            () => {
                setIsSubmittingForm(false);
            });
    }

    const changeSuccessMessage = (message: string) => {
        const newMessage = setMessage(message, successMessage ?? "");
        setSuccessMessage(newMessage);
    }

    const changeErrorMessage = (message: string) => {
        const newMessage = setMessage(message, errorMessage ?? "");
        setErrorMessage(newMessage);
    }

    const mapFormData = (formData: IReferralForm): ISaveReferral => {
        const data: ISaveReferral = {
            patientId: formData.patientId,
            patientPhoneNumber: formData.patientPhoneNumber,
            patientEmail: formData.patientEmail,
            referralId: formData.referralId,
            externalIdFromReferrer: formData.externalIdFromReferrer,
            referrerName: formData.referrerName,
            referralReason: formData.referralReason,
            referralText: formData.referralText,
            referralNote: formData.referralNote,
            recipentCareProviderId: formData.recipentCareProviderId,
            referrerCareProviderId: formData.otherReferrer ? undefined : formData.referrerCareProviderId,
            specialityId: formData.specialityId,
        };

        if (formData.otherReferrer) {
            const address: IAddress = {
                address: formData.referrerStreetName,
                zipCode: formData.referrerPostalCode,
                city: formData.referrerPostalCity,
                phoneNumber: formData.referrerTelephoneNumber,
                alternativePhoneNumber: formData.referrerAltTelephoneNumber,
                emailAddress: formData.referrerEmailAddress,
                addressName: formData.referrerAddressName
            }
            data.referrerAddress = address;
        }
        return data;
    }


    return (
        <SpinnerWrapper isLoading={isApiLoading}>
            <Form>
                <section className="card">
                    <div className="card-header">
                        <div className="row referral-header-row">
                            <div className="col">
                                <h1>Registrera specialistremiss</h1>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                        <AlertMessage alertType={AlertType.success} duration={3000}>{successMessage}</AlertMessage>
                        <ReferralManualRegisterFormInputs patient={patient} referralData={initData} />
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-6 text-left">
                                <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                            </div>
                            {
                                initData ?
                                    <div className="col-6 text-right">
                                        <CustomSubmitButton isLoading={isSubmittingForm} onButtonSubmit={submitReferralForm}>Registrera specialistremiss</CustomSubmitButton>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </section>
            </Form>
        </SpinnerWrapper>
    );
}